export let Content = [
  {
    image: "planets/planet_(6).png",
    name: "About Us",
    Top: "5rem",
    Left: "10rem",
    link: "/aboutus",
  },
  {
    image: "planets/planet_(5).png",
    name: "Team",
    Top: "3rem",
    Left: "44rem",
    link: "/our-team",
  },
  {
    image: "./planets/planet_(4).png",
    name: "Vision",
    Top: "10rem",
    Right: "3rem",
    link: "/our-vision",
  },
  {
    image: "./planets/planet_(3).png",
    name: "Projects",
    Bottom: "10rem",
    Left: "4rem",
    link: "/projects",
  },

  {
    image: "./planets/planet_(2).png",
    name: "Explore More",
    Bottom: "6rem",
    Right: "12rem",
    link: "/explore-more",
  },
  {
    image: "./planets/planet_(1).png",
    name: "Events",
    Bottom: "10px",
    Left: "30rem",
    link: "/events",
  },
];